import type { FC } from "react";
import { hasWindow, noop } from "@litres/utils";
import React, { useState } from "react";
import cn from "classnames";
import { MobileModal } from "@litres/ui-kit/mobile-modal";
import { SimpleSearch } from "@litres-modules/simple-search";
import { SearchForm } from "./SearchForm";
import { SearchResult } from "../SearchResult/SearchResult";
import type { ISearchResultItem } from "../types";

import { trackerSearchClickInput } from "../utils";
import styles from "./MobileSuggestionsSearch.module.scss";

interface MobileSuggestionsSearchProps {
  searchValue: string;
  searchResultItems: ISearchResultItem[];
  onSearchChange: (value: string) => void;
  onItemClick: (item: ISearchResultItem, index?: number) => void;
  onItemDeleteClick: (value: string) => void;
  onSearch: (q: string) => void;
  onClearClick?: () => void;
}

export const MobileSuggestionsSearch: FC<MobileSuggestionsSearchProps> = ({
  searchValue,
  searchResultItems,
  onSearchChange,
  onItemClick,
  onItemDeleteClick,
  onSearch,
  onClearClick = noop,
}) => {
  const [isVisibleSearchModal, setSearchModalVisibility] =
    useState<boolean>(false);

  const handleSearchClick = () => {
    setSearchModalVisibility(true);
    trackerSearchClickInput(hasWindow ? window.location.href : "");
  };

  const handleItemClick = (item: ISearchResultItem, index?: number) => {
    setSearchModalVisibility(false);
    onItemClick(item, index);
  };

  const handleSearchSubmitClick = (
    event: React.MouseEvent<HTMLFormElement, MouseEvent>
  ) => {
    event.preventDefault();
    setSearchModalVisibility(true);
  };

  const handleBackClick = () => {
    setSearchModalVisibility(false);
  };

  return (
    <div className={cn(styles.search, { [styles.mobileSearch]: true })}>
      {/* SimpleSearch исполняет роль opener */}
      <SimpleSearch
        onClick={handleSearchClick}
        onSubmit={handleSearchSubmitClick}
        searchValue={searchValue}
        placeholder="Искать на Литрес"
        handleClear={onClearClick}
      />

      <MobileModal
        visible={isVisibleSearchModal}
        head={
          <SearchForm
            onChange={onSearchChange}
            onSearchClick={() => {
              onSearch(searchValue);
            }}
            value={searchValue}
            onClearClick={onClearClick}
          />
        }
        content={
          <SearchResult
            items={searchResultItems}
            isDesktop={false}
            isUserAnonymous={false}
            onItemClick={handleItemClick}
            onItemDeleteClick={onItemDeleteClick}
          />
        }
        onBackClick={handleBackClick}
        className={styles.mobileSuggestionsSearch}
        contentClassName={styles.mobileSuggestionsSearch__modalContent}
      />
    </div>
  );
};
